export const PUBLIC_ROUTES: readonly string[] = [
  '/login',
  '/magic-link',
  '/forgot-password',
  '/reset-password',
  '/invite',
  '/invitations/accept',
];

export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`));
}
